import type { User, Store } from '@/lib/types/database'
import type { ApiUserWithTeams } from './users'

export function mapApiUserToUser(apiUser: ApiUserWithTeams): User {
  return {
    id: String(apiUser.id),
    email: apiUser.email,
    name: [apiUser.firstName, apiUser.lastName].filter(Boolean).join(' ') || apiUser.email,
    firstName: apiUser.firstName,
    lastName: apiUser.lastName,
    admin: apiUser.admin,
    store_ids: apiUser.storeIds,
    created_at: apiUser.createdAt,
    updated_at: apiUser.updatedAt,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapApiStoreToStore(s: any): Store {
  return {
    id: s.id,
    name: s.name,
    organization_type: s.organizationType ?? s.organization_type,
    parent_group_id: s.parentGroupId ?? s.parent_group_id ?? null,
    oem: s.oem,
    address: s.address,
    city: s.city,
    state: s.state,
    zip: s.zip,
    phone: s.phone,
    labor_rate: s.laborRate ?? s.labor_rate ?? 0,
    created_at: s.createdAt ?? s.created_at,
    updated_at: s.updatedAt ?? s.updated_at,
  }
}
